import styled from 'styled-components';

export const StyledBetaButton = styled.button`
  appearance: none;
  background: ${props => props.theme.themeColors.beta.button.background};
  border: 1px solid ${props => props.theme.themeColors.beta.button.border};
  bottom: 160px;
  box-shadow: ${props => props.theme.themeColors.beta.button.boxShadow};
  cursor: pointer;
  font-size: 1rem;
  left: 0;
  margin: 0;
  padding: 1em 2em;
  position: fixed;
  z-index: 1000;

  &:hover {
    background: ${props =>
      props.theme.themeColors.beta.button.backgroundOnHover};

    > svg {
      path {
        fill: ${props => props.theme.themeColors.beta.button.backgroundOnHover};
        stroke: ${props =>
          props.theme.themeColors.beta.button.iconColorOnHover};
      }
    }
  }

  &:active {
    background: ${props =>
      props.theme.themeColors.beta.button.backgroundOnActive};
    > svg {
      path {
        fill: ${props =>
          props.theme.themeColors.beta.button.backgroundOnActive};
        stroke: ${props =>
          props.theme.themeColors.beta.button.iconColorOnActive};
      }
    }
  }
`;
